export default __webpack_public_path__ + "static/media/433.7ef794be.svg";